

/// <reference path="StockNoteProductLine.ts" />

// Generated class MovementNoteLine_ManagedObject

class MovementNoteLine_ManagedObject extends StockNoteProductLine
{
}
